import { CreditCard, ArrowRight } from 'lucide-react';
import { Button } from '../../../tailwind/button';
import { Card, CardContent } from '../../../tailwind/card';
import { cn } from '../../../../lib/utils';
import { formatWalletCurrency, isLowBalance } from '../../../../utils/wallet/walletUtils';
import { LOW_BALANCE_THRESHOLD } from '../../../../utils/wallet/walletConstants';
import { waBtn, waSoft } from '../../../../pages/whatsapp/utils/whatsappUiTokens';
import { EstimateCreditCostButton } from './EstimateCreditCostButton';

export function WalletBalanceCard({
  balance,
  warningThreshold = LOW_BALANCE_THRESHOLD,
  onRecharge,
}) {
  const lowBalance = isLowBalance(balance, warningThreshold);

  return (
    <Card className="bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800 shadow-sm wa-card-hover">
      <CardContent className="p-6 sm:p-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex flex-col gap-1 w-full md:w-auto">
            <div className="flex items-center gap-2 mb-1">
              <div className={cn('h-7 w-7 rounded-full flex items-center justify-center', waSoft.bg)}>
                <CreditCard className={cn('h-3.5 w-3.5', waSoft.text)} />
              </div>
              <span className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                Available Credits
              </span>
            </div>
            <h3
              className={cn(
                'text-4xl font-extrabold tracking-tight',
                lowBalance ? 'text-red-600 dark:text-red-400' : 'text-gray-900 dark:text-white'
              )}
            >
              {formatWalletCurrency(balance)}
            </h3>
            {lowBalance && (
              <p className="text-sm text-red-600 dark:text-red-400 mt-1">
                Balance is low — recharge to keep messaging uninterrupted.
              </p>
            )}
          </div>

          <div className="flex flex-col sm:flex-row md:flex-col gap-3 w-full md:w-auto md:items-stretch">
            <EstimateCreditCostButton
              className={cn(waBtn.secondary, 'h-10 px-5 w-full md:w-auto')}
            />
            <Button
              className={cn(waBtn.primary, 'gap-2 h-11 px-6 w-full md:w-auto')}
              onClick={onRecharge}
            >
              Recharge Wallet
              <ArrowRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
